import ActionMenuBasePartialView from 'js/view-partial/action-menu/base';
import HeartActionItemPartialView from 'js/view-partial/action-item/heart';
import PopUpMenuPartialView from 'js/view-partial/popup-menu';
import TextViewHelper from 'js/view-helper/text';
import UrlViewHelper from 'js/view-helper/url';

export default class ActionMenuChildCommentPartialView extends ActionMenuBasePartialView {
  render() {
    const $b = $(`
      <div class="icons">
        <em><i class="fas fa-link actionable"></i></em>
      </div>
    `);
    this.$b = $b;

    // heart icon 挿入
    const ht = new HeartActionItemPartialView({
      c: this.c,
      parentView: this,
    });
    ht.render().appendTo($b);

    // 値を挿入
    this._setDataToDom(this.md);

    // click action 定義
    this._initActions();
    return $b;
  }

  _initActions() {
    super._initActions();
    const {$b} = this;

    // tweet link
    const turl = UrlViewHelper.urlFor('childComment', 'detail', {
      topicId: this.md.topicId,
      id: this.md.id,
    });
    const twUrl = UrlViewHelper.tweetUrlFor(turl);

    // link button は popup menu を開く
    const lopt = {
      c: this.c,
      className: 'link',
      $opener: $b.find('i.fa-link'),
      def: [
        {action: 'tweet', text: 'Tweet する', url: twUrl},
        {action: 'copy-link', text: 'リンクをコピー'},
      ],
    };
    const lpop = new PopUpMenuPartialView(lopt);
    lpop.setActionFor('copy-link', () => {
      TextViewHelper.copyToClipboard(turl);
      console.log('copy link to clipboard', turl);
    });
    lpop.render().appendTo($b);
  }
}
